import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// import RightArrow from '../../assets/images/right-arrow.png';

export default function LendingServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Lending Services</title>
        <meta
          name='description'
          content='Long after the ribbon is cut, we keep your investment performing beautifully.'
        />
        <meta
          name='keywords'
          content='Starlife, Lending Services, investment, property management, real estate, investment performance'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          Lending Services | Flexible funding for dynamic ventures
        </h2>
        <p className='service-page-text'>
          Starlife Lending offers capital solutions for developers and investors
          needing fast, custom financing. We help turn plans into progress
          without delays.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Services</h2>
        <div className='service-list'>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block'
          >
            <h3>Lending solutions through Starlife Lending</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block green-block'
          >
            <h3>Construction loans, bridge loans, and private financing</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
